var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"col-11"},[_c('v-row',{class:`${_vm.currentClass} pr-3`},[_c('v-col',{staticClass:"text-truncate",attrs:{"title":_vm.printValue}},[_vm._v(" "+_vm._s(_vm.printValue)+" ")])],1)],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }